// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2153":"f373bd23c7dca7c5","2888":"15db46e15ec0fbb7","3139":"98aef725e41d9710","7951":"0458c5b50a6f68e6"}[chunkId] + ".css";
};